import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { BehaviorSubject, filter, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BrandingService {
  private readonly _logoUrl$ = new BehaviorSubject<string | null | undefined>(undefined);

  readonly logoUrl$: Observable<string | null | undefined> = this._logoUrl$.asObservable();

  constructor(private router: Router) {
    this.router.events
      .pipe(filter((e): e is NavigationStart => e instanceof NavigationStart))
      .subscribe(e => {
        this._logoUrl$.next(this.isDynamicBrandingRoute(e.url) ? undefined : null);
      });
  }

  set(logoUrl: string | null): void {
    this._logoUrl$.next(logoUrl);
  }

  private isDynamicBrandingRoute(url: string): boolean {
    return url.startsWith('/patient-register/');
  }
}
